// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const prodConfig = {
  apiKey: "AIzaSyBw-EKa-2Zq5RjEvAxvDMa8jLNCOwOf1b4",
  authDomain: "bst-fellowship.firebaseapp.com",
  databaseURL: "https://bst-fellowship.firebaseio.com",
  projectId: "bst-fellowship",
  storageBucket: "bst-fellowship.appspot.com",
  messagingSenderId: "165634322818",
  appId: "1:165634322818:web:36291e233e04cdb7ad5f9b",
  measurementId: "G-CFKCRWGDD5"
};

const developConfig = {
  apiKey: "AIzaSyCcuBY7uPNTL-olDZeB56DfHVWPqIGE8es",
  authDomain: "bst-fellowship-dev.firebaseapp.com",
  projectId: "bst-fellowship-dev",
  storageBucket: "bst-fellowship-dev.appspot.com",
  messagingSenderId: "621564089057",
  appId: "1:621564089057:web:cd22664fb36fc90371dda0",
  measurementId: "G-17DRPG59LF"
}

const localConfig = prodConfig;
// const localConfig = developConfig;

export default process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ? prodConfig : 
  process.env.REACT_APP_DEPLOYMENT_ENV === 'develop' ? developConfig :
  localConfig;